import { constants, useServices, useTranslation } from 'cng-web-lib'

import SmsConfigurationApiUrls from 'src/apiUrls/SmsConfigurationApiUrls'
import React, { useRef, useState } from 'react'
import moment from 'moment'
import SmsConfigurationKeys from 'src/constants/locale/key/SmsConfiguration'
import Namespace from 'src/constants/locale/Namespace'
import pathMap from '../../paths/pathMap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AlertDialog from '../../components/aciacehighway/AlertDialog'
import { generatePath } from 'react-router'
import Table from '../../components/aciacehighway/Table'
import _ from 'lodash'

const {
  filter: { BETWEEN, IN, LIKE }
} = constants

function TablePage(props) {
  const { history, showNotification } = props

  const [alertDialog, setAlertDialog] = useState({ open: false, smsConfiguration: null })
  const tableRef = useRef(null)
  const { deleteRecord } = useServices()
  const { translate } = useTranslation(Namespace.SMS_CONFIGURATION)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let content = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CONTENT
    )
    let startDate = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.START_DATE
    )
    let endDate = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.END_DATE
    )
    let priority = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.PRIORITY
    )
    let active = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.ACTIVE
    )
    let createButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CREATE_BUTTON
    )
    let editButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.EDIT_BUTTON
    )
    let deleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.DELETE_BUTTON
    )
    let deleteContent = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.DELETE_CONTENT
    )
    let cancelDeleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CANCEL_DELETE_BUTTON
    )
    let confirmDeleteButton = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.CONFIRM_DELETE_BUTTON
    )
    let activeOption = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.ACTIVE_OPTION
    )
    let inactiveOption = translate(
      Namespace.SMS_CONFIGURATION,
      SmsConfigurationKeys.INACTIVE_OPTION
    )

    return {
      content,
      startDate,
      endDate,
      priority,
      active,
      createButton,
      editButton,
      deleteButton,
      deleteContent,
      cancelDeleteButton,
      confirmDeleteButton,
      activeOption,
      inactiveOption,
    }
  }

  const columns = [
    {
      field: "content",
      title: translatedTextsObject.content,
    },
    {
      field: "startDate",
      title: translatedTextsObject.startDate,
      render: (data) =>
        data.startDate && moment.utc(data.startDate).format('YYYY-MM-DD')
    },
    {
      field: "endDate",
      title: translatedTextsObject.endDate,
      render: (data) =>
        data.endDate && moment.utc(data.endDate).format('YYYY-MM-DD')
    },
    {
      field: "priority",
      title: translatedTextsObject.priority,
    },
    {
      field: "active",
      title: translatedTextsObject.active,
      render: (data) =>
        data.active ? translatedTextsObject.activeOption : translatedTextsObject.inactiveOption
    }
  ]

  const filters = [
    {
      label: translatedTextsObject.content,
      type: 'textfield',
      name: 'content',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.startDate,
      type: 'daterange',
      name: 'startDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.endDate,
      type: 'daterange',
      name: 'endDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.priority,
      type: 'textfield',
      name: 'priority',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.active,
      type: 'checkbox',
      name: 'active',
      operatorType: IN,
      options: [
        {
          fullWidth: true,
          label: translatedTextsObject.activeOption,
          value: 'true',
          filterValue: { value: 'true' }
        },
        {
          fullWidth: true,
          label: translatedTextsObject.inactiveOption,
          value: 'false',
          filterValue: { value: 'false' }
        },
      ]
    },
  ]

  function handleDeleteSmsConfiguration() {
    if (!_.isEmpty(alertDialog.smsConfiguration)) {
      deleteRecord.execute(
        SmsConfigurationApiUrls.DELETE,
        alertDialog.smsConfiguration,
        () => {
          showNotification('success', 'Delete succeeded')
          setAlertDialog({ open: false, smsConfiguration: null })

          if (tableRef.current?.performRefresh) {
            tableRef.current.performRefresh()
          }
        },
        (error) => console.log(error)
      )
    }
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.SMS_CONFIGURATION_ADD_VIEW)
            },
            label: translatedTextsObject.createButton
          }
        ]}
        columns={columns}
        compact
        exportData={{ url: SmsConfigurationApiUrls.EXPORT }}
        fetch={{ url: SmsConfigurationApiUrls.GET }}
        filters={filters}
        onRowClick={(rowData) =>
          history.push(
            generatePath(pathMap.SMS_CONFIGURATION_EDIT_VIEW, { id: rowData.id })
          )
        }
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: translatedTextsObject.editButton,
            onClick: (rowData) =>
              history.push(
                generatePath(pathMap.SMS_CONFIGURATION_EDIT_VIEW, { id: rowData.id })
              )
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: translatedTextsObject.deleteButton,
            onClick: (rowData) => setAlertDialog({ open: true, smsConfiguration: rowData })
          }
        ]}
        showNotification={showNotification}
        persistSettings
        tableRef={tableRef}
      />
      <AlertDialog
        cancelLabel={translatedTextsObject.cancelDeleteButton}
        confirmLabel={translatedTextsObject.confirmDeleteButton}
        open={alertDialog.open}
        onClose={() => setAlertDialog({ open: false, smsConfiguration: null })}
        onCancel={() => setAlertDialog({ open: false, smsConfiguration: null })}
        onConfirm={handleDeleteSmsConfiguration}
        title={translatedTextsObject.deleteButton}
      >
        {translatedTextsObject.deleteContent}
      </AlertDialog>
    </>
  )
}

export default TablePage
